var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'bg-yellow': _vm.$route.name === 'awards-list'
  },attrs:{"id":"app"}},[_c('page-header',{class:[_vm.$route.meta.isWhiteHeader ? 'theme--white' : ''],attrs:{"logo":_vm.isShowLogo}}),_c('div',{staticClass:"page-main-body"},[_c('router-view')],1),(_vm.isShowFooter)?_c('page-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }